export const HAND_WRITTEN_SOURCE_TYPE = 'handwritten';
export const VACANCIES_PAGE_SOURCE_TYPE = 'vacanciesPage';
export const WIDGET_SOURCE_TYPE = 'widget';

export const sourceTypeTranslator = {
  [VACANCIES_PAGE_SOURCE_TYPE]: 'Страница вакансий',
  [WIDGET_SOURCE_TYPE]: 'Виджет',
  [HAND_WRITTEN_SOURCE_TYPE]: 'Не указано',
};
